import { motion } from 'framer-motion';
import { useLocation, useOutlet } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import FloatingCTAs from './FloatingCTAs';
import CursorLight from './CursorLight';
import SmoothScroll from './SmoothScroll';
import OnLoadCurtain from './OnLoadCurtain';
import BackButton from './BackButton';

export default function Layout() {
  const outlet = useOutlet();
  const location = useLocation();

  // Reset scroll on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'auto' : 'auto' });
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen bg-ink-950 text-white grain">
      <SmoothScroll />
      <CursorLight />
      <OnLoadCurtain />
      <Navbar />

      <BackButton />

      <motion.main
        key={location.pathname}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.6, ease: [0.2, 0.8, 0.2, 1] }}
      >
        {outlet}
      </motion.main>

      <Footer />
      <FloatingCTAs />
    </div>
  );
}
